import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/settings/metric/")({
  beforeLoad: () => {
    throw redirect({
      to: "/settings/metric/zones",
    })
  },
})
